import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

const enum fields {
    title = "title",
    description = "description",
}

interface CustomProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.description]: string;
    };
}

export interface UnauthorizedAccessMeassageStyles {
    mainContainer?: InjectableCss;
    lowerContainer?: InjectableCss;
}

export const unauthorizedAccessMeassageStyles: UnauthorizedAccessMeassageStyles = {

    mainContainer: {
        css: css`
        font-size: 20px;
        line-height: 25px;
        color: #000;
        font-weight: 400;
        margin-bottom: 10px;
        `,
    },
    lowerContainer: {
        css: css`
        font-size: 16px;
        line-height: 24px;
        color: #000;
        font-weight: 400;
        `,
    }
};

const styles = unauthorizedAccessMeassageStyles;

type Props = WidgetProps & CustomProps;

const UnauthorizedAccessMeassage: React.FunctionComponent<Props> = ({ fields }) => {

    return (
        <>
            <StyledWrapper as="h2" {...styles.mainContainer}>
                {fields.title || "Unauthorized Access"}
            </StyledWrapper>
            <StyledWrapper {...styles.lowerContainer}>
                {fields.description || "We're sorry. You do not have permissions to view the page you are trying to visit."}
            </StyledWrapper>
        </>
    );

};

const widgetModule: WidgetModule = {
    component: UnauthorizedAccessMeassage,
    definition: {
        group: "Basic",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Unauthorized access title overrided",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.description,
                displayName: "Unauthorized access description overrided",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;